module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop.5388f9b6.png";